'use client';

import Link from 'next/link';
import React from 'react';
import { LocaleContext } from '@/contexts/LocaleContext';
import { useLocaleFromPath } from '@/hooks/useLocaleFromPath';
import { getPathForLocale, type Locale } from '@/lib/i18n';

type LocalizedLinkProps = React.ComponentProps<typeof Link>;

export function LocalizedLink({ href, ...props }: LocalizedLinkProps) {
  const contextLocale = React.useContext(LocaleContext);
  const pathLocale = useLocaleFromPath();
  const locale = (contextLocale?.locale ?? pathLocale) as Locale;

  const resolvedHref =
    typeof href === 'string'
      ? href.startsWith('/')
        ? getPathForLocale(locale, href)
        : href
      : typeof href === 'object' && href.pathname
        ? { ...href, pathname: getPathForLocale(locale, href.pathname ?? '/') }
        : href;
  return <Link href={resolvedHref} {...props} />;
}
